import type { OIDCUser } from "../../src/auth/types";
import type { ExpertProfile } from "../../src/state";

const PR_NUMBER = (import.meta.env.VITE_PR_NUMBER ?? crypto.randomUUID()) as string;

export const isE2EUser = (oidcUser: OIDCUser) => oidcUser.profile.sub.includes("E2E") && !oidcUser.profile.employeeID;

export const formatE2EUser = (oidcUser: OIDCUser): ExpertProfile => ({
    firstName: `E2E-${PR_NUMBER}`,
    lastName: oidcUser.profile.family_name,
    email: oidcUser.profile.email,
    id: oidcUser.profile.family_name + `-${PR_NUMBER}`,
});
